import Dropdown from "./Dropdown";
import ChatIcon from "./ChatIcon";
import { useCallback, useEffect, useState } from "react";
import { useClickOutside } from "../../../app/layouts/Header";
import NotificationDropdownList from "../../../features/notification/components/NotificationDropdownList";
import { getInboxNotifications } from "../../../features/notification/api/notification.api";
import { subscribeNotifications } from "../../../features/notification/notification.store";
import { useProfile } from "../../../features/auth/hooks/useProfile";

const Notifications: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);

  const close = useCallback(() => setOpen(false), []);
  const ref = useClickOutside(close);
  const { isAuthenticated } = useProfile();

  useEffect(() => {
    if (!isAuthenticated) return;

    const fetchUnread = async () => {
      const res = await getInboxNotifications({ page: 1, limit: 10 });

      if (res.success) {
        const messages = res.data.rows;
        const unreadExists = messages.some((m: any) => m.read === 0);
        setHasUnread(unreadExists);
      }
    };

    fetchUnread();

    const unsubscribe = subscribeNotifications(fetchUnread);

    return () => unsubscribe();
  }, [isAuthenticated]);

  return (
    <div ref={ref} className="relative h-full flex items-center">

      <button
        onClick={() => setOpen((v) => !v)}
        className={[
          "relative flex flex-col items-center justify-center h-full transition-colors duration-200 cursor-pointer border-0",
          "px-2 md:px-6 xl:px-7",
          "xl:border-l-2 xl:border-l-[#f5f6f9]",
          open
            ? "bg-[#3b519c] text-white"
            : "bg-transparent text-[#26295e] hover:bg-[#f5f6f9]",
        ].join(" ")}
      >
        <ChatIcon className="w-6 h-6 xl:w-8 xl:h-8" />

        {hasUnread && (
          <span className="absolute top-2 right-2 w-2.5 h-2.5 bg-red-500 rounded-full" />
        )}
      </button>

      <Dropdown
        isOpen={open}
        className="right-0 w-[320px] sm:w-[360px] md:w-[420px] max-w-[95vw]"
        arrowRight={28}
      >
        <NotificationDropdownList close={close} />
      </Dropdown>
    </div>
  );
};

export default Notifications;